'use client';

import React from 'react';
import { motion } from 'framer-motion';
import styles from './ServiceBadge.module.css';

interface ServiceBadgeProps {
    text: string;
    className?: string;
}

export const ServiceBadge = ({ text, className }: ServiceBadgeProps) => {
    const isOnline = text.toLowerCase() === 'online';
    const isNew = text.toLowerCase() === 'новинка';

    const badgeClasses = [
        styles.badge,
        isOnline ? styles.online : '',
        isNew ? styles.new : '',
        !isOnline && !isNew ? styles.default : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <motion.div
            className={badgeClasses}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2 }}
        >
            <motion.span
                animate={
                    isOnline
                        ? {
                              opacity: [0.7, 1, 0.7],
                              scale: [1, 1.02, 1],
                          }
                        : {}
                }
                transition={
                    isOnline
                        ? {
                              duration: 2,
                              repeat: Infinity,
                              ease: 'easeInOut',
                          }
                        : {}
                }
            >
                {text}
            </motion.span>
        </motion.div>
    );
};
